import React from 'react';
import { useTranslation } from 'react-i18next';
import { SOLUTION_LABEL_KEYS } from './_utils';

// ── Icônes thématiques villes CA ─────────────────────────────────────────────
export const CaCityIcon = ({ city, size = 14 }: { city: string; size?: number }) => {
  const c = city.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const s = size;
  const props = { width: s, height: s, viewBox: "0 0 32 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" as const, role: "img" as const, "aria-label": city };
  const col = "currentColor";

  if (c.includes('paris')) return (
    <svg {...props}><title>Paris</title>
      <path d="M16 52 L12 52 L14 36 L11 28 L16 10 L21 28 L18 36 Z" fill="none" stroke={col} strokeWidth="2" strokeLinejoin="round"/>
      <line x1="13" y1="28" x2="19" y2="28" stroke={col} strokeWidth="1.8"/>
      <line x1="12" y1="38" x2="20" y2="38" stroke={col} strokeWidth="1.8"/>
      <line x1="11" y1="44" x2="21" y2="44" stroke={col} strokeWidth="1.8"/>
    </svg>
  );
  if (c.includes('lyon')) return (
    <svg {...props}><title>Lyon</title>
      <rect x="4" y="32" width="24" height="20" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M4 32 L16 20 L28 32" fill="none" stroke={col} strokeWidth="2" strokeLinejoin="round"/>
      <rect x="2" y="22" width="6" height="14" fill="none" stroke={col} strokeWidth="1.8"/>
      <rect x="24" y="22" width="6" height="14" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M2 22 Q5 16 8 22" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M24 22 Q27 16 30 22" fill="none" stroke={col} strokeWidth="1.8"/>
      <rect x="9" y="38" width="6" height="14" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="17" y="38" width="6" height="14" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('rouen')) return (
    <svg {...props}><title>Rouen</title>
      <rect x="5" y="26" width="22" height="26" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <line x1="16" y1="26" x2="16" y2="8" stroke={col} strokeWidth="2"/>
      <path d="M12 20 L16 8 L20 20" fill="none" stroke={col} strokeWidth="1.8"/>
      <circle cx="16" cy="34" r="5" fill="none" stroke={col} strokeWidth="1.5"/>
      <line x1="16" y1="29" x2="16" y2="39" stroke={col} strokeWidth="1"/>
      <line x1="11" y1="34" x2="21" y2="34" stroke={col} strokeWidth="1"/>
      <path d="M11 52 L11 41 Q16 35 21 41 L21 52" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('douai')) return (
    <svg {...props}><title>Douai</title>
      <rect x="8" y="20" width="16" height="32" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="10" y="8" width="12" height="16" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M10 8 Q16 2 22 8" fill="none" stroke={col} strokeWidth="2"/>
      <circle cx="16" cy="16" r="4" fill="none" stroke={col} strokeWidth="1.5"/>
      <line x1="16" y1="16" x2="16" y2="12" stroke={col} strokeWidth="1"/>
      <line x1="16" y1="16" x2="19" y2="16" stroke={col} strokeWidth="1"/>
      <rect x="11" y="28" width="4" height="7" rx="1" fill="none" stroke={col} strokeWidth="1.2"/>
      <rect x="17" y="28" width="4" height="7" rx="1" fill="none" stroke={col} strokeWidth="1.2"/>
    </svg>
  );
  if (c.includes('orleans') || c.includes('orléans')) return (
    <svg {...props}><title>Orléans</title>
      <rect x="4" y="24" width="24" height="28" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="4" y="10" width="8" height="18" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="20" y="10" width="8" height="18" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M4 10 L8 2 L12 10" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M20 10 L24 2 L28 10" fill="none" stroke={col} strokeWidth="1.8"/>
      <circle cx="16" cy="30" r="5" fill="none" stroke={col} strokeWidth="1.5"/>
      <path d="M11 52 L11 40 Q16 33 21 40 L21 52" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('bordeaux')) return (
    <svg {...props}><title>Bordeaux</title>
      <rect x="2" y="20" width="28" height="32" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <line x1="9"  y1="20" x2="9"  y2="52" stroke={col} strokeWidth="1.5"/>
      <line x1="16" y1="20" x2="16" y2="52" stroke={col} strokeWidth="1.5"/>
      <line x1="23" y1="20" x2="23" y2="52" stroke={col} strokeWidth="1.5"/>
      <path d="M2 20 L16 8 L30 20" fill="none" stroke={col} strokeWidth="2" strokeLinejoin="round"/>
      <path d="M10 20 Q16 12 22 20" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('aix')) return (
    <svg {...props}><title>Aix-en-Provence</title>
      <path d="M12 20 Q16 13 20 20 Q20 26 16 26 Q12 26 12 20Z" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M7 36 Q16 27 25 36 Q25 44 16 44 Q7 44 7 36Z" fill="none" stroke={col} strokeWidth="2"/>
      <line x1="16" y1="13" x2="16" y2="6" stroke={col} strokeWidth="1.8" strokeDasharray="2 2"/>
      <path d="M13 9 Q16 4 19 9" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="13" y="44" width="6" height="8" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('versailles')) return (
    <svg {...props}><title>Versailles</title>
      <rect x="2" y="24" width="28" height="28" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="2"  y="28" width="8" height="18" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="22" y="28" width="8" height="18" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="8"  y="24" width="16" height="20" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M8 24 L16 14 L24 24" fill="none" stroke={col} strokeWidth="1.8"/>
      <rect x="11" y="28" width="4" height="7" rx="1" fill="none" stroke={col} strokeWidth="1"/>
      <rect x="17" y="28" width="4" height="7" rx="1" fill="none" stroke={col} strokeWidth="1"/>
    </svg>
  );
  if (c.includes('montpellier')) return (
    <svg {...props}><title>Montpellier</title>
      <path d="M6 52 L6 28 Q16 12 26 28 L26 52" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M10 52 L10 32 Q16 20 22 32 L22 52" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="4" y="22" width="24" height="6" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="6" y="12" width="20" height="10" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('rennes')) return (
    <svg {...props}><title>Rennes</title>
      <rect x="2" y="22" width="28" height="30" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M2 22 L16 8 L30 22" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="6" y="26" width="7" height="10" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="19" y="26" width="7" height="10" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
      <path d="M9 42 L9 52 Q16 46 23 52 L23 42" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('toulouse')) return (
    <svg {...props}><title>Toulouse</title>
      <rect x="2" y="18" width="28" height="34" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <line x1="10" y1="18" x2="10" y2="52" stroke={col} strokeWidth="1.2"/>
      <line x1="22" y1="18" x2="22" y2="52" stroke={col} strokeWidth="1.2"/>
      <rect x="2"  y="8" width="8"  height="12" fill="none" stroke={col} strokeWidth="1.8"/>
      <rect x="12" y="8" width="8"  height="12" fill="none" stroke={col} strokeWidth="1.8"/>
      <rect x="22" y="8" width="8"  height="12" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M2  8 L6  2 L10 8"  fill="none" stroke={col} strokeWidth="1.2"/>
      <path d="M12 8 L16 2 L20 8" fill="none" stroke={col} strokeWidth="1.2"/>
      <path d="M22 8 L26 2 L30 8" fill="none" stroke={col} strokeWidth="1.2"/>
    </svg>
  );
  if (c.includes('marseille')) return (
    <svg {...props}><title>Marseille</title>
      <rect x="6" y="28" width="20" height="24" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="10" y="16" width="12" height="16" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M10 16 Q16 6 22 16" fill="none" stroke={col} strokeWidth="2"/>
      <line x1="16" y1="6" x2="16" y2="2" stroke={col} strokeWidth="2"/>
      <circle cx="16" cy="2" r="2" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="10" y="36" width="5" height="16" rx="1" fill="none" stroke={col} strokeWidth="1.2"/>
      <rect x="17" y="36" width="5" height="16" rx="1" fill="none" stroke={col} strokeWidth="1.2"/>
    </svg>
  );
  if (c.includes('nantes')) return (
    <svg {...props}><title>Nantes</title>
      <rect x="4" y="22" width="24" height="30" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="4"  y="12" width="7" height="14" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="21" y="12" width="7" height="14" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M4 12 L5 8 L6 12 M7 12 L8 8 L9 12 M10 12 L11 8" stroke={col} strokeWidth="1.2" fill="none"/>
      <path d="M21 12 L22 8 L23 12 M24 12 L25 8 L26 12 M27 12 L28 8" stroke={col} strokeWidth="1.2" fill="none"/>
      <rect x="12" y="32" width="8" height="20" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('strasbourg')) return (
    <svg {...props}><title>Strasbourg</title>
      <rect x="5" y="24" width="22" height="28" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="9" y="12" width="14" height="16" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M9 12 L16 2 L23 12" fill="none" stroke={col} strokeWidth="2"/>
      <line x1="16" y1="2" x2="16" y2="0" stroke={col} strokeWidth="1.5"/>
      <circle cx="16" cy="29" r="5" fill="none" stroke={col} strokeWidth="1.5"/>
      <path d="M10 52 L10 40 Q16 33 22 40 L22 52" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('nancy')) return (
    <svg {...props}><title>Nancy</title>
      <rect x="2" y="18" width="28" height="34" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M2 28 Q7 23 12 28" fill="none" stroke={col} strokeWidth="1.5"/>
      <path d="M20 28 Q25 23 30 28" fill="none" stroke={col} strokeWidth="1.5"/>
      <rect x="10" y="18" width="12" height="34" fill="none" stroke={col} strokeWidth="1.5"/>
      <path d="M2 18 L16 8 L30 18" fill="none" stroke={col} strokeWidth="2"/>
      <circle cx="16" cy="14" r="3" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('grenoble')) return (
    <svg {...props}><title>Grenoble</title>
      <path d="M2 52 L10 28 L16 38 L22 18 L30 52Z" fill="none" stroke={col} strokeWidth="2" strokeLinejoin="round"/>
      <rect x="12" y="34" width="8" height="8" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M12 34 L13 30 L14 34 M15 34 L16 30 L17 34 M18 34 L19 30 L20 34" stroke={col} strokeWidth="1" fill="none"/>
    </svg>
  );
  if (c.includes('reims')) return (
    <svg {...props}><title>Reims</title>
      <rect x="4" y="26" width="24" height="26" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="4"  y="12" width="8" height="18" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="20" y="12" width="8" height="18" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M4  12 L8  4 L12 12" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M20 12 L24 4 L28 12" fill="none" stroke={col} strokeWidth="1.8"/>
      <circle cx="16" cy="32" r="5" fill="none" stroke={col} strokeWidth="1.5"/>
      <path d="M10 52 L10 40 Q16 34 22 40 L22 52" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  if (c.includes('pau')) return (
    <svg {...props}><title>Pau</title>
      <rect x="4" y="22" width="24" height="30" rx="1" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="4"  y="10" width="7" height="16" fill="none" stroke={col} strokeWidth="2"/>
      <rect x="21" y="10" width="7" height="16" fill="none" stroke={col} strokeWidth="2"/>
      <path d="M4  10 L7.5 2 L11 10" fill="none" stroke={col} strokeWidth="1.8"/>
      <path d="M21 10 L24.5 2 L28 10" fill="none" stroke={col} strokeWidth="1.8"/>
      <rect x="11" y="30" width="10" height="22" rx="1" fill="none" stroke={col} strokeWidth="1.5"/>
    </svg>
  );
  return (
    <svg {...props}><title>{city}</title>
      <path d="M16 4 C10 4 6 9 6 16 C6 26 16 38 16 38 C16 38 26 26 26 16 C26 9 22 4 16 4Z" fill="none" stroke={col} strokeWidth="2"/>
      <circle cx="16" cy="16" r="5" fill="none" stroke={col} strokeWidth="1.8"/>
    </svg>
  );
};

// ── SolutionIcon ──────────────────────────────────────────────────────────────
export const SolutionIcon = ({ solution, size = 22 }: { solution?: string; size?: number }) => {
  const { t } = useTranslation();
  const s = (solution || '').toLowerCase().trim();
  const label = SOLUTION_LABEL_KEYS[s] ? t(SOLUTION_LABEL_KEYS[s]) : s;

  if (s === 'cassation' || s === 'infirmation') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#fee2e2"/>
      <line x1="10" y1="38" x2="28" y2="20" stroke="#dc2626" strokeWidth="4" strokeLinecap="round"/>
      <rect x="24" y="10" width="14" height="9" rx="2.5" fill="#dc2626" transform="rotate(-45 31 14)"/>
      <path d="M14 34 l4-4 l-2-3 l4-4" fill="none" stroke="#dc2626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity=".5"/>
    </svg>
  );
  if (s === 'rejet' || s === 'confirmation') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#dcfce7"/>
      <path d="M24 10 L36 15 L36 26 Q36 35 24 40 Q12 35 12 26 L12 15 Z" fill="#16a34a" fillOpacity=".2" stroke="#16a34a" strokeWidth="2"/>
      <path d="M17 24 l5 5 l9-9" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  if (s === 'nonlieu' || s === 'non-admission' || s === 'non admission') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#fef9c3"/>
      <rect x="13" y="12" width="22" height="26" rx="2" fill="none" stroke="#ca8a04" strokeWidth="2"/>
      <circle cx="31" cy="25" r="2.5" fill="#ca8a04"/>
      <line x1="13" y1="12" x2="13" y2="38" stroke="#ca8a04" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="19" y1="18" x2="29" y2="32" stroke="#ca8a04" strokeWidth="1.5" strokeLinecap="round" opacity=".6"/>
      <line x1="29" y1="18" x2="19" y2="32" stroke="#ca8a04" strokeWidth="1.5" strokeLinecap="round" opacity=".6"/>
    </svg>
  );
  if (s === 'irrecevabilite' || s === 'irrecevabilité' || s === 'decheance' || s === 'déchéance') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#fef3c7"/>
      <circle cx="24" cy="24" r="13" fill="none" stroke="#d97706" strokeWidth="2.5"/>
      <line x1="14" y1="14" x2="34" y2="34" stroke="#d97706" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );
  if (s === 'renvoi' || s === 'annulation' || s === 'rabat' || s === 'reglement' || s === 'désignation' || s === 'designation') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#ede9fe"/>
      <path d="M24 12 A12 12 0 1 1 12 24" fill="none" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round"/>
      <polygon points="12,17 12,24 19,24" fill="#7c3aed"/>
    </svg>
  );
  if (s.includes('partiel')) return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#fef3c7"/>
      <path d="M12 26 l5 5 l9-9" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="30" y1="16" x2="38" y2="24" stroke="#dc2626" strokeWidth="2" strokeLinecap="round"/>
      <line x1="38" y1="16" x2="30" y2="24" stroke="#dc2626" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  if (s === 'avis' || s === 'qpc' || s === 'qpcother') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label} role="img">
      <circle cx="24" cy="24" r="24" fill="#dbeafe"/>
      <path d="M12 14 h24 a3 3 0 0 1 3 3 v12 a3 3 0 0 1-3 3 h-14 l-6 5 v-5 h-4 a3 3 0 0 1-3-3 v-12 a3 3 0 0 1 3-3z" fill="#2563eb" fillOpacity=".15" stroke="#2563eb" strokeWidth="1.8"/>
      <line x1="18" y1="22" x2="30" y2="22" stroke="#2563eb" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="18" y1="27" x2="26" y2="27" stroke="#2563eb" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
  if (s === 'desistement' || s === 'désistement') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={t('fiche.solution.desistement')} role="img">
      <circle cx="24" cy="24" r="24" fill="#e0f2fe"/>
      <path d="M10 26 Q14 20 20 22 L24 24 L28 22 Q34 20 38 26" fill="none" stroke="#0284c7" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M20 22 L24 26 L28 22" fill="none" stroke="#0284c7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="24" y1="26" x2="24" y2="34" stroke="#0284c7" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  if (s === 'mainlevee' || s === 'mainlevée') return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={t('fiche.solution.mainlevee')} role="img">
      <circle cx="24" cy="24" r="24" fill="#ede9fe"/>
      <rect x="14" y="12" width="16" height="24" rx="2" fill="none" stroke="#7c3aed" strokeWidth="2"/>
      <path d="M30 18 l6 6 l-6 6" fill="none" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="30" y1="24" x2="20" y2="24" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={t('fiche.solution.other')} role="img">
      <circle cx="24" cy="24" r="24" fill="#f1f5f9"/>
      <text x="24" y="32" textAnchor="middle" fontFamily="system-ui,sans-serif" fontSize="22" fontWeight="700" fill="#94a3b8">?</text>
    </svg>
  );
};